import moment from "moment";

export const filterByUserEndDate = (c, selectedMonth) => {
    const endOfMonth = moment(selectedMonth.value).endOf('month');
    const userEndDate = c._user?.contract_end_date
        ? moment(c._user.contract_end_date).endOf('month')
        : null;

    if (userEndDate && userEndDate < endOfMonth) {
        return false;
    }

    return true;
}